import CancelIcon from '@mui/icons-material/Cancel'
import MuiPhotoIcon from '@mui/icons-material/Photo'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import OverflowFilename from 'components/ui/OverflowFilename'

const PhotoIcon = styled(MuiPhotoIcon)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginRight: theme.spacing(1),
}))
const InvalidFileIcon = styled(CancelIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
}))

interface Props {
  filename: string
  onRemove: () => void
  invalid: boolean
}
const FileItem = ({ filename, invalid, onRemove }: Props) => (
  <Box display="flex" alignItems="center" justifyContent="space-between">
    <Box display="flex" alignItems="center">
      {invalid ? <InvalidFileIcon color="error" /> : <PhotoIcon />}
      <OverflowFilename filename={filename} />
    </Box>
    <IconButton aria-label="delete" onClick={onRemove}>
      <RemoveCircleOutlineIcon fontSize="small" />
    </IconButton>
  </Box>
)

export default FileItem
